export default "__VITE_ASSET__BRuj_SIf__"